































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class AppModal extends Vue {

    @Prop() private noHeader!: boolean;
    @Prop() private noFooter!: boolean;

    private body = document.querySelector('body');
    private modalIn = false;

    private close() {
        this.modalIn = false;
        setTimeout(() => {
            this.$emit('close');
        }, 100);

    }

    private mounted() {
        if (this.body) {
            this.body.setAttribute('style', 'overflow: hidden;');
        }
        setTimeout(() => {
          this.modalIn = true;
        }, 100);
    }

    private destroyed() {
        this.modalIn = false;
        if (this.body) {
            this.body.setAttribute('style', 'overflow: auto;');
        }
    }

}
